import useOnResolve from '../hooks/use-on-resolve'

export default function RemoveEmptyConstraintsOnResolve () {
  function clean (obj) {
    if (typeof obj !== 'object' || obj === null || Array.isArray(obj) || Object.keys(obj).length === 0) {
      return obj
    }

    const keys = Object.keys(obj)

    if (keys.length > 0) {
      keys.forEach(key => {
        clean(obj[key])

        const val = obj[key]

        if ((val === null || typeof val === 'undefined' || val === '' || (typeof val === 'object' && Object.keys(val).length === 0))) {
          delete obj[key]
        }
      })
    }
  }

  useOnResolve((constraints) => {
    return new Promise(resolve => {
      clean(constraints)
      resolve(constraints)
    })
  })

  return null
}
